module.exports = __webpack_public_path__ + "img/3-6_Rename_Nodes.796829af.png";